<template>
  <div class="media-viewer">
    <div class="close-btn" @click="close"><i class="fal fa-times"></i></div>

    <div class="image" v-if="type == mediaViewerTypes.IMAGE">
      <img :src="src">
    </div>

    <div class="map" v-if="type == mediaViewerTypes.MAP">
      <div class="location-info">{{ src.lat + ' , ' + src.lng }}</div>
      <LocationMap :location="src" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import LocationMap from '@/components/maps/LocationMap.vue'
import { MarkerPosition } from '@/types//Maps'

@Component({
  components: {
    LocationMap
  }
})
export default class Fillgrid extends Vue {
  type = 0
  src: any

  mediaViewerTypes = {
    IMAGE: 1,
    PDF: 2,
    MAP: 3
  }

  close () {
    window.close()
  }

  created () {
    switch (this.$route.params.type) {
      case 'img':
        this.type = this.mediaViewerTypes.IMAGE
        this.src = this.$route.query.src
        break
      case 'map':
        this.type = this.mediaViewerTypes.MAP
        this.src = new MarkerPosition(Number(this.$route.query.lat), Number(this.$route.query.lng))
        break
    }
  }
}
</script>

<style lang="scss" scoped>
.media-viewer {
  z-index: 2;
  height: 100%;
  .close-btn {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px 15px;
    font-size: 1.75rem;
    color: #777;
    cursor: pointer;
  }
  .image {
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    overflow: auto;
    padding: 50px 50px 35px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .map {
    padding: 55px 45px 0 45px;
    height: 100%;
    .location-info {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      padding: 8px 20px;
      background-color: var(--secondary);
      color: #fff;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      font-weight: 300;
    }
    .vue-map-container {
      box-shadow: 0 5px 25px -2px #8a8a8a;
    }
  }
}
</style>
